import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "card-header border-0 pt-5" }, [
  /*#__PURE__*/_createVNode("h3", { class: "card-title align-items-start flex-column" }, [
    /*#__PURE__*/_createVNode("span", { class: "card-label fw-bolder fs-3 mb-1" }, "Gift Cheque History       ")
  ])
], -1)
const _hoisted_2 = { class: "card-body py-3" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_5 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createVNode("th", { class: "ps-4 min-w-125px rounded-start" }, "#"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-100px" }, "User ID"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-350px" }, "Product Description"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Date"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Ticket No."),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Released By"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Released Date"),
    /*#__PURE__*/_createVNode("th", { class: "min-w-200px" }, "Status")
  ])
], -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createVNode("option", {
  value: "x",
  selected: ""
}, "Please select an option", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("option", {
  value: "x",
  selected: ""
}, "Please select an option", -1)
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { key: 3 }
const _hoisted_12 = { key: 4 }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _withDirectives(_createVNode("div", null, [
      _createVNode(_component_el_skeleton, {
        rows: 10,
        animated: ""
      })
    ], 512), [
      [_vShow, _ctx.loading]
    ]),
    _withDirectives(_createVNode("div", {
      class: [_ctx.widgetClasses, "card"]
    }, [
      _hoisted_1,
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("table", _hoisted_4, [
            _hoisted_5,
            _createVNode("tbody", null, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
                return (_openBlock(), _createBlock("tr", { key: index }, [
                  _createVNode("td", null, "   " + _toDisplayString(index + 1), 1),
                  _createVNode("td", null, _toDisplayString(item.usid), 1),
                  (item.pcode == 'I2' && item.doneoptionsubmit != 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_6, [
                        _createTextVNode(_toDisplayString(item.pdesc) + " ", 1),
                        (_ctx.redeemOptions.length === 0)
                          ? (_openBlock(), _createBlock("select", {
                              key: 0,
                              class: "form-select form-select-solid col-md-4 mb-2",
                              onClick: ($event: any) => (_ctx.loadRedeemOptions(item.pcode))
                            }, [
                              _hoisted_7
                            ], 8, ["onClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.redeemOptions.length !== 0)
                          ? _withDirectives((_openBlock(), _createBlock("select", {
                              key: 1,
                              class: "form-select form-select-solid col-md-4 mb-2",
                              "onUpdate:modelValue": ($event: any) => (_ctx.gc.options[index] = $event)
                            }, [
                              _hoisted_8,
                              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.redeemOptions, (item, index) => {
                                return (_openBlock(), _createBlock("option", {
                                  key: index,
                                  value: item.option_id
                                }, _toDisplayString(item.option_desc), 9, ["value"]))
                              }), 128))
                            ], 8, ["onUpdate:modelValue"])), [
                              [_vModelSelect, _ctx.gc.options[index]]
                            ])
                          : _createCommentVNode("", true),
                        _createVNode("button", {
                          type: "button",
                          class: "form-control btn btn-success er fs-6 px-8 py-2",
                          onClick: ($event: any) => {_ctx.submitGCOption(item.pcode, item.recid, index, item.pin1);}
                        }, " Submit ", 8, ["onClick"])
                      ]))
                    : (_openBlock(), _createBlock("td", _hoisted_9, _toDisplayString(item.pdesc), 1)),
                  _createVNode("td", null, _toDisplayString(item.dteStp), 1),
                  _createVNode("td", null, _toDisplayString(item.pin1), 1),
                  _createVNode("td", null, _toDisplayString(item.releasedBy), 1),
                  (item.releasedDte === 'Jan  1 1900 12:00AM')
                    ? (_openBlock(), _createBlock("td", _hoisted_10))
                    : (_openBlock(), _createBlock("td", _hoisted_11, _toDisplayString(item.releasedDte), 1)),
                  (item.releasedSts == 1)
                    ? (_openBlock(), _createBlock("td", _hoisted_12, "Released"))
                    : (_openBlock(), _createBlock(_Fragment, { key: 5 }, [
                        (item.releasedSts == 10)
                          ? (_openBlock(), _createBlock("td", _hoisted_13, "Claimed"))
                          : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                              (item.releasedSts == 11)
                                ? (_openBlock(), _createBlock("td", _hoisted_14, "Verified"))
                                : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                    (item.releasedSts == 99)
                                      ? (_openBlock(), _createBlock("td", _hoisted_15, "Converted to Swatch"))
                                      : (_openBlock(), _createBlock("td", _hoisted_16, "Pending"))
                                  ], 64))
                            ], 64))
                      ], 64))
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ], 2), [
      [_vShow, !_ctx.loading]
    ])
  ], 64))
}